// Domain
import { CustomerAddressRepository } from '../../../domain/repositories/customer-address-repository';
import { CustomerAddressDto } from '../../../domain/dtos/customer-address-dto';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CustomerAddressDummyRepository implements CustomerAddressRepository {
  update(payload: CustomerAddressDto): Promise<void> {
    return Promise.resolve();
  }
}
